import React, { Component } from "react";

import twitter from "./images/twitter.png";

class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <div style={footerWrapper}>
          <div style={footerStyle}>
            <p style={footerTextStyle}>© 2020</p>
            <p style={twitterTextStyle}>
              Twitter:{" "}
              <a href="https://twitter.com/isalacuerva" target="_href"> @isalacuerva</a>
            </p>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const footerWrapper = {
  width: "100%",
  backgroundColor: "#eee",
  margin: "auto",
  textAlign: "right",
  color: "black",
  padding: "1rem 0 2rem 0",
};

const footerStyle = {
  maxWidth: "1100px",
  margin: "0 auto",
};

const footerTextStyle = {
  margin: "8px 20px 0px 0px",
};

const twitterTextStyle = {
  margin: "0px 20px 18px 0px",
};

export default Footer;
